/**
 * Round "?" help button — v2 chip-style.
 *
 * Visually matches the chips in `SnakeTopBar` / `FroggerTopBar` and the
 * yellow leaderboard button: same bevel stack (drop shadow → dark rim →
 * main fill → top highlight → faded white inner stroke), same Poppins
 * typography. Cyan body so it reads as the "info" companion to the gold
 * scores button — matches the v2 mockup.
 */

import { Container, Text, TextStyle } from '../../vendor/pixi.min.mjs';
import { paintCircleButton } from './shared.js';

const SIZE = 60;
const BG_COLOR = 0x22d3ee;  // cyan — matches the v2 mockup's info button

const LABEL_STYLE = new TextStyle({
    fontFamily: 'Poppins, Arial, sans-serif',
    fontSize: 34,
    fontWeight: '900',
    fill: '#ffffff',
    dropShadow: { color: '#0e4f5a', alpha: 0.6, distance: 1, blur: 2 },
});

/**
 * @param {number} x — centre x
 * @param {number} y — centre y
 * @param {() => void} onTap
 * @returns {Container}
 */
export function createHelpButton(x, y, onTap) {
    const btn = new Container();
    btn.eventMode = 'static';
    btn.cursor = 'pointer';
    btn.x = x;
    btn.y = y;

    const chip = paintCircleButton({ size: SIZE, color: BG_COLOR });
    btn.addChild(chip);

    const label = new Text({ text: '?', style: LABEL_STYLE });
    label.anchor.set(0.5);
    label.y = -2;
    btn.addChild(label);

    btn.on('pointertap', onTap);
    btn.on('pointerover', () => { btn.scale.set(1.06); });
    btn.on('pointerout',  () => { btn.scale.set(1.0);  });
    btn.on('pointerdown', () => { btn.scale.set(0.94); });
    btn.on('pointerup',   () => { btn.scale.set(1.06); });
    return btn;
}
